import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'

import { Login } from './view/login/login'
import { LoginAs } from './view/loginAs/loginAs'
import { resetPasswordRoute } from './view/reset/route'

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: Login,
})

export const loginAsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login-as',
  component: LoginAs,
})

export { resetPasswordRoute }
